import { mapValues } from 'lodash';
/**
 * Version 35 migration - Updating table header defaults in Hotel Request
 */
export default function v35(website) {
  return {
    ...website,
    eventVersion: 35,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'HotelRequest') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            style: {
              ...layoutItem.config.style,
              tableTitle: {
                ...layoutItem.config.style.tableTitle,
                styleMapping: 'body1',
                customSettings: {
                  ...layoutItem.config.style.tableTitle.customSettings,
                  spacing: {
                    padding: {
                      paddingBottom: 5,
                      paddingTop: 5,
                      paddingLeft: 20,
                      paddingRight: 20
                    }
                  }
                }
              },
              ownAccommodation: {
                ...layoutItem.config.style.ownAccommodation,
                styleMapping: 'body1'
              }
            }
          }
        };
      } else if (layoutItem.widgetType === 'AirRequest') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            style: {
              ...layoutItem.config.style,
              ownReservation: {
                ...layoutItem.config.style.ownReservation,
                customSettings: {
                  ...layoutItem.config.style.ownReservation.customSettings,
                  spacing: {
                    padding: {
                      paddingBottom: 16,
                      paddingTop: 16,
                      paddingLeft: 16,
                      paddingRight: 16
                    }
                  }
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
